/* NIGHTWEAVE · nw2.js — scroll choreography. No dependencies, transform/opacity only. */
(function () {
  'use strict';
  var reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* ---------- Reveal on enter ---------- */
  var revealIO = new IntersectionObserver(function (entries) {
    entries.forEach(function (e) {
      /* Reveal when visible, or when already scrolled past (fast scrolls can skip crossings) */
      if (e.isIntersecting || e.boundingClientRect.top < 0) {
        var el = e.target;
        el.classList.add('nw-in'); revealIO.unobserve(el);
        /* Guarantee final state even if the rendering timeline stalls (occluded tab, odd engines) */
        if (el.hasAttribute('data-nw-reveal')) {
          setTimeout(function () { el.style.opacity = '1'; el.style.transform = 'none'; }, 1800);
        }
      }
    });
  }, { rootMargin: '0px 0px -5% 0px', threshold: 0.04 });

  document.querySelectorAll('[data-nw-reveal], .nw2-hero, .nw2-material__stack, .nw2-ritual__img, .nw2-finale__scene')
    .forEach(function (el) { revealIO.observe(el); });

  /* ---------- Header state ---------- */
  var header = document.querySelector('.nw2-header');
  if (header) {
    var onScrollHeader = function () {
      header.classList.toggle('nw-solid', window.scrollY > 40);
    };
    onScrollHeader();
    window.addEventListener('scroll', onScrollHeader, { passive: true });
  }

  /* ---------- Animated counters ---------- */
  function animateCount(el) {
    var target = parseFloat(el.getAttribute('data-nw-count'));
    var decimals = (el.getAttribute('data-nw-count').split('.')[1] || '').length;
    var dur = 1600, t0 = null;
    function frame(t) {
      if (!t0) t0 = t;
      var p = Math.min((t - t0) / dur, 1);
      var eased = 1 - Math.pow(1 - p, 4);
      el.textContent = (target * eased).toFixed(decimals).replace(/\B(?=(\d{3})+(?!\d))/g, ',');
      if (p < 1) requestAnimationFrame(frame);
    }
    if (reduced) { el.textContent = target.toLocaleString(); return; }
    requestAnimationFrame(frame);
  }
  var countIO = new IntersectionObserver(function (entries) {
    entries.forEach(function (e) {
      if (e.isIntersecting) { animateCount(e.target); countIO.unobserve(e.target); }
    });
  }, { threshold: 0.6 });
  document.querySelectorAll('[data-nw-count]').forEach(function (el) { countIO.observe(el); });

  /* ---------- Night arc: scroll-scrubbed scene ---------- */
  var arc = document.querySelector('.nw2-arc');
  if (arc) {
    var sticky = arc.querySelector('.nw2-arc__sticky');
    var phases = Array.prototype.slice.call(arc.querySelectorAll('.nw2-arc__phase'));
    var clock = arc.querySelector('[data-nw-clock]');
    var ticking = false;

    /* Night timeline: 22:47 → 06:31 */
    var T0 = 22 * 60 + 47, SPAN = (24 * 60 - T0) + (6 * 60 + 31);

    function fmt(mins) {
      var m = ((mins % (24 * 60)) + 24 * 60) % (24 * 60);
      var h = Math.floor(m / 60), mm = m % 60;
      var ap = h >= 12 ? 'PM' : 'AM';
      var h12 = h % 12; if (h12 === 0) h12 = 12;
      return h12 + ':' + (mm < 10 ? '0' : '') + mm + ' ' + ap;
    }

    function updateArc() {
      ticking = false;
      var rect = arc.getBoundingClientRect();
      var total = arc.offsetHeight - window.innerHeight;
      var p = Math.min(Math.max(-rect.top / total, 0), 1);
      sticky.style.setProperty('--nw-p', p.toFixed(4));
      if (clock) clock.textContent = fmt(Math.round(T0 + p * SPAN));
      var idx = Math.min(Math.floor(p * phases.length), phases.length - 1);
      phases.forEach(function (ph, i) { ph.classList.toggle('nw-live', i === idx); });
    }
    function onScrollArc() {
      if (!ticking) { ticking = true; requestAnimationFrame(updateArc); }
    }
    if (reduced) {
      arc.style.height = 'auto';
      sticky.style.position = 'relative';
      sticky.style.height = 'auto';
      sticky.style.display = 'block';
      phases.forEach(function (ph) {
        ph.classList.add('nw-live');
        ph.style.position = 'relative';
        ph.style.padding = '60px 20px';
      });
    } else {
      updateArc();
      window.addEventListener('scroll', onScrollArc, { passive: true });
      window.addEventListener('resize', onScrollArc, { passive: true });
    }
  }

  /* ---------- Gentle parallax depths ---------- */
  var depthEls = Array.prototype.slice.call(document.querySelectorAll('[data-nw-depth]'));
  if (depthEls.length && !reduced) {
    var depthTick = false;
    function updateDepth() {
      depthTick = false;
      var vh = window.innerHeight;
      depthEls.forEach(function (el) {
        var r = el.getBoundingClientRect();
        if (r.bottom < -80 || r.top > vh + 80) return;
        var center = (r.top + r.height / 2 - vh / 2) / vh;
        var depth = parseFloat(el.getAttribute('data-nw-depth')) || 0.1;
        el.style.transform = 'translate3d(0,' + (-center * depth * 100).toFixed(2) + 'px,0)';
      });
    }
    window.addEventListener('scroll', function () {
      if (!depthTick) { depthTick = true; requestAnimationFrame(updateDepth); }
    }, { passive: true });
    updateDepth();
  }

  /* ---------- Cursor: lavender stardust trail ---------- */
  if (window.matchMedia('(pointer: fine)').matches && !reduced) {
    var dot = document.createElement('div');
    var canvas = document.createElement('canvas');
    dot.className = 'nw2-cursor-dot';
    canvas.className = 'nw2-cursor-trail';
    dot.setAttribute('aria-hidden', 'true');
    canvas.setAttribute('aria-hidden', 'true');
    document.body.appendChild(canvas);
    document.body.appendChild(dot);

    var ctx = canvas.getContext('2d');
    var dpr = Math.min(window.devicePixelRatio || 1, 2);
    function sizeCanvas() {
      canvas.width = Math.floor(window.innerWidth * dpr);
      canvas.height = Math.floor(window.innerHeight * dpr);
    }
    sizeCanvas();
    window.addEventListener('resize', sizeCanvas, { passive: true });

    var mx = window.innerWidth / 2, my = window.innerHeight / 2;
    var lastX = null, lastY = null, cursorOn = false;
    var parts = [], MAXP = 90;

    function spawn(x, y, dx, dy) {
      var dist = Math.hypot(dx, dy);
      if (dist < 1.5) return;
      var n = Math.min(1 + Math.floor(dist / 7), 4);
      for (var i = 0; i < n; i++) {
        if (parts.length >= MAXP) parts.shift();
        var t = Math.random();
        parts.push({
          x: x - dx * t + (Math.random() - 0.5) * 7,
          y: y - dy * t + (Math.random() - 0.5) * 7,
          vx: (Math.random() - 0.5) * 0.35,
          vy: -0.2 - Math.random() * 0.4,
          r: 0.8 + Math.random() * 1.8,
          life: 1,
          decay: 0.014 + Math.random() * 0.02
        });
      }
    }

    document.addEventListener('pointermove', function (e) {
      mx = e.clientX; my = e.clientY;
      if (!cursorOn) { cursorOn = true; document.body.classList.add('nw2-cursor-on'); }
      if (lastX !== null) spawn(mx, my, mx - lastX, my - lastY);
      lastX = mx; lastY = my;
      var t = e.target && e.target.closest
        ? e.target.closest('a, button, label, summary, input, select, [role="button"]')
        : null;
      document.body.classList.toggle('nw2-cursor-hover', !!t);
    }, { passive: true });
    document.addEventListener('pointerdown', function () { document.body.classList.add('nw2-cursor-down'); }, { passive: true });
    document.addEventListener('pointerup', function () { document.body.classList.remove('nw2-cursor-down'); }, { passive: true });
    document.documentElement.addEventListener('mouseleave', function () {
      cursorOn = false; document.body.classList.remove('nw2-cursor-on');
    });

    (function cursorLoop() {
      dot.style.transform = 'translate3d(' + mx + 'px,' + my + 'px,0)';

      /* stardust */
      ctx.clearRect(0, 0, canvas.width, canvas.height);
      for (var i = parts.length - 1; i >= 0; i--) {
        var p = parts[i];
        p.life -= p.decay;
        if (p.life <= 0) { parts.splice(i, 1); continue; }
        p.x += p.vx; p.y += p.vy;
        var a = p.life * p.life;
        var r = p.r * (0.35 + 0.65 * p.life) * dpr;
        /* soft outer glow */
        ctx.beginPath();
        ctx.arc(p.x * dpr, p.y * dpr, r * 2.6, 0, 6.2832);
        ctx.fillStyle = 'rgba(196, 181, 230, ' + (a * 0.14).toFixed(3) + ')';
        ctx.fill();
        /* bright core */
        ctx.beginPath();
        ctx.arc(p.x * dpr, p.y * dpr, r, 0, 6.2832);
        ctx.fillStyle = 'rgba(225, 216, 245, ' + (a * 0.85).toFixed(3) + ')';
        ctx.fill();
      }
      requestAnimationFrame(cursorLoop);
    })();
  }

  /* ---------- Offer: bundle price sync ---------- */
  var offerForm = document.querySelector('[data-nw-offer]');
  if (offerForm) {
    var cta = offerForm.querySelector('[data-nw-offer-cta]');
    offerForm.addEventListener('change', function (e) {
      var input = e.target.closest('input[name="id"]');
      if (input && cta) {
        cta.querySelector('b').textContent = input.getAttribute('data-nw-price-label') || '';
      }
    });
  }
})();
